module.exports = __webpack_public_path__ + "media/promo/velle/images/products/prod_2-5907f886bd43e1b5b6b4d1c6281fa813.png";